var _path, _path2, _path3, _g, _circle, _circle2, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponFree = function SvgCouponFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0FAF2",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5F2DA",
    d: "M28.788 19.088c.45.45.887.918 1.357 1.348.306.28.31.465 0 .76-1.995 1.9-4.265 3.375-6.855 4.306-6.614 2.377-12.902 1.665-18.81-2.133-.98-.63-1.83-1.465-2.744-2.198-.287-.233-.297-.418-.02-.685.963-.938 1.908-1.893 2.85-2.85.25-.25.423-.283.703-.018 2.026 1.9 4.381 3.215 7.096 3.806 5.211 1.135 9.874-.023 13.932-3.506.706-.605.695-.615 1.348.033l1.14 1.14z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "couponFree_svg__a",
    width: 25,
    height: 21,
    x: 4,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M15.956 26.43c-5.707-.083-9.82-2.517-10.995-3.44l.335-16.284h22.41l1.292 14.597-1.71 1.518c-3.022 2.686-9.146 3.642-11.332 3.61"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#couponFree_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.476 8.562h15.14v13.165H5.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#269636",
    d: "m10.083 12.782-.163.927H8.456l-.09.516H9.42l-.158.88H8.208l-.247 1.405H6.79l.659-3.728zm2.134 0q.6 0 .911.268a.9.9 0 0 1 .31.716q0 .132-.02.238a1.35 1.35 0 0 1-.327.668q-.258.285-.669.411l.559 1.427h-1.285l-.469-1.337-.237 1.337H9.82l.66-3.728zm-.853 1.611h.463a.42.42 0 0 0 .264-.074.4.4 0 0 0 .131-.242.4.4 0 0 0 .006-.068.22.22 0 0 0-.074-.18q-.074-.068-.216-.068h-.463zm3.649-.684-.079.463h1.159l-.158.88h-1.159l-.095.526h1.317l-.163.932h-2.486l.658-3.728h2.486l-.163.927zm2.926 0-.079.463h1.159l-.158.88h-1.159l-.095.526h1.317l-.163.932h-2.486l.659-3.728h2.485l-.163.927zM20.948 21.727V10.86l4.414.104 1.262 5.443 1.894.026v5.294h-7.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.238 12.484h1.817l.948 3.95h-2.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59C969",
    d: "M5.476 20.41h23.04v1.316H5.476z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81,
    cy: 1.81,
    r: 1.81,
    fill: "#269636",
    transform: "matrix(1 0 0 -1 6.134 25.677)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81,
    cy: 1.81,
    r: 1.81,
    fill: "#269636",
    transform: "matrix(1 0 0 -1 22.593 25.677)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81,
    cy: 1.81,
    r: 1.81,
    fill: "#269636",
    transform: "matrix(1 0 0 -1 11.403 25.677)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#269636",
    d: "m1.84 11.364.095.296c.1.313.345.559.659.659l.296.094-.296.094c-.314.1-.56.346-.66.66l-.094.295-.094-.296a1.01 1.01 0 0 0-.659-.659l-.296-.094.296-.095c.314-.1.56-.345.659-.658zM30.168 9.091l.126.395c.133.418.46.745.878.878l.395.126-.395.126c-.418.133-.745.46-.878.879l-.126.394-.126-.394a1.35 1.35 0 0 0-.878-.879l-.395-.126.395-.126c.417-.133.745-.46.878-.878zM4.747 4l.157.493c.167.522.576.931 1.098 1.098l.494.157-.494.157a1.7 1.7 0 0 0-1.098 1.098l-.157.494-.157-.494a1.7 1.7 0 0 0-1.098-1.098l-.494-.157.494-.157A1.7 1.7 0 0 0 4.59 4.493z"
  })));
};
export default SvgCouponFree;